// extracted by mini-css-extract-plugin
export var emoji = "Emoji-module--emoji--EDlk9";
export var show = "Emoji-module--show--19yUf";
export var showFadeInDown = "Emoji-module--show-fade-in-down--3RWqI";
export var showFadeInUp = "Emoji-module--show-fade-in-up--3LTtI";
export var hideFadeOut = "Emoji-module--hide-fade-out--11TZX";